import { render } from "./courseSelect.vue?vue&type=template&id=24189dda&scoped=true"
import script from "./courseSelect.vue?vue&type=script&lang=js"
export * from "./courseSelect.vue?vue&type=script&lang=js"

import "./courseSelect.vue?vue&type=style&index=0&id=24189dda&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24189dda"]])

export default __exports__